module.exports = __webpack_public_path__ + "img/ts8.4d654e92.png";